var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendarLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2.25h-.75V.75h-1.5v1.5h-7.5V.75h-1.5v1.5H2c-.825 0-1.5.675-1.5 1.5v12c0 .825.675 1.5 1.5 1.5h12c.825 0 1.5-.675 1.5-1.5v-12c0-.825-.675-1.5-1.5-1.5zm0 13.5H2V7.5h12v8.25zM14 6H2V3.75h12V6z",
    fill: "url(#calendarLight_svg__paint0_linear_10875_67955)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendarLight_svg__paint0_linear_10875_67955",
    x1: 15.5,
    y1: 17.25,
    x2: 0.5,
    y2: 17.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BCEF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311,
    stopColor: "#98D3F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#92E1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DECE0"
  })))));
}

export default SvgCalendarLight;